export default __webpack_public_path__ + "410a97fa9b505656430fb999b3e284f1.svg";